import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
    useCreateBoostAction,
    useCreateBurnAction,
    useTransaction,
} from '../../hooks/waxActions'
import MainButton from '../common/util/input/MainButton'
import Popup from './Popup'
import { Card } from '@nextui-org/react'
import Link from '../common/util/input/Link'
import { useSharedState } from '../waxplorer/Waxplorer'

const BurnPopup = ({ asset, callBack, closeCallBack }) => {
    const { t } = useTranslation('common')

    const { name, backedTokens } = asset

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const createBoostAction = useCreateBoostAction()
    const createBurnAction = useCreateBurnAction()

    const actions =
        typeof window !== undefined
            ? useMemo(
                  () => [createBoostAction(), createBurnAction(asset)],
                  [asset],
              )
            : ''

    const startBurn = useTransaction(actions, async (error, result) => {
        closeCallBack()

        const res = await result

        callBack({
            success: error === undefined,
            asset,
            transactionId: res?.response?.transaction_id,
            error: error ? error.message : '',
        })
    })

    const cancel = () => {
        callBack({
            burned: false,
            asset,
        })
        closeCallBack()
    }

    return (
        <Popup
            title={t('popups.burn.title', { assetName: name })}
            asset={asset}
            cancel={cancel}
        >
            <div className="mx-auto mb-4 mr-4 text-xl font-bold">
                {t('popups.burn.question', { assetName: name })}
            </div>
            {backedTokens ? (
                <>
                    <div className="mx-auto mb-4 mr-4 text-xl font-bold">
                        {t('popups.burn.backed_info', { x: backedTokens })}
                    </div>
                    <div className="mx-auto mb-4 mr-4 text-xl font-bold">
                        {t('popups.burn.burn_info_backed')}
                    </div>
                    <Link
                        href={`/user/${userName}?view=wallet`}
                        external={true}
                    >
                        <div className="mx-auto mb-4 mr-4 text-xl font-bold text-primary hover:underline">
                            Wallet
                        </div>
                    </Link>
                </>
            ) : (
                ''
            )}
            <Card className="p-4">
                <div className="flex justify-center mx-auto mb-4 text-xl font-bold">
                    <img
                        className={'h-5 mx-2'}
                        src={'/Warning_icn.svg'}
                        alt={'Warning'}
                    />
                    <div className={'text-sm text-primary'}>
                        {t('popups.burn.explanation', { assetName: name })}
                    </div>
                </div>
            </Card>
            <div className="flex justify-start flex-1 gap-2 mt-4">
                <MainButton onClick={cancel} className="bg-red-500 ">
                    {t('asset.cancel')}
                </MainButton>
                <MainButton onClick={startBurn}>{t('asset.burn')}</MainButton>
            </div>
        </Popup>
    )
}

export default BurnPopup
